<span *ngIf="!priceOverride">|</span>
<span class="pds-text"> PDS </span>
<span
  #tooltip
  class="custom-tooltip"
  [class.top]="top"
  [class.top1]="top && !cpi"
>
  <ul>
    <li *ngIf="cpi">Supplier CPI = {{ cpi }}</li>
    <li *ngIf="fee">PDS Fee = {{ fee }}</li>
  </ul>
  <p *ngIf="priceOverride">
    Price Override = {{ priceOverride | currency : currencySymbol }}
  </p>
  <p *ngFor="let supplier of pdsSuppliers">
    PDS | {{ supplier.name }} =
    {{
      supplier.BCPIfx
        ? supplier.BCPIfx
        : (supplier.BCPI | currency : currencySymbol)
    }}
  </p>
</span>
